import { SvelteComponent, init, safe_not_equal, assign, create_component, mount_component, transition_in, transition_out, destroy_component, element, space, empty, set_attributes, toggle_class, attr, insert, append, listen, get_spread_update, check_outros, detach, subscribe, group_outros, noop } from '../../external_node_modules/svelte/internal/index.mjs.js';
import { PURCHASE_STATUSES } from '../../constants/purchaseStatuses.js';
import { disableBodyOverflow } from '../../utils/disableBodyOverflow.js';
import Loader from './components/Loader.svelte.js';
import './App.css.js';

/* src/ui/PurchaseConfirmation/App.svelte generated by Svelte v3.44.2 */

function create_if_block(ctx) {
	let loader;
	let current;
	loader = new Loader({});

	return {
		c() {
			create_component(loader.$$.fragment);
		},
		m(target, anchor) {
			mount_component(loader, target, anchor);
			current = true;
		},
		i(local) {
			if (current) return;
			transition_in(loader.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(loader.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(loader, detaching);
		}
	};
}

function create_fragment(ctx) {
	let div;
	let iframe;
	let t;
	let if_block_anchor;
	let current;
	let mounted;
	let dispose;

	let iframe_levels = [
		{
			class: "purchase-confirmation-bridge__iframe"
		},
		/*attributes*/ ctx[1]
	];

	let iframe_data = {};

	for (let i = 0; i < iframe_levels.length; i += 1) {
		iframe_data = assign(iframe_data, iframe_levels[i]);
	}

	let if_block = /*$isLoading*/ ctx[3] && create_if_block();

	return {
		c() {
			div = element("div");
			iframe = element("iframe");
			t = space();
			if (if_block) if_block.c();
			if_block_anchor = empty();
			set_attributes(iframe, iframe_data);
			toggle_class(iframe, "wcl-1elol4w", true);
			attr(div, "class", "purchase-confirmation-bridge wcl-1elol4w");
			attr(div, "style", /*styles*/ ctx[2]);
			toggle_class(div, "hidden", /*$isLoading*/ ctx[3]);
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, iframe);
			insert(target, t, anchor);
			if (if_block) if_block.m(target, anchor);
			insert(target, if_block_anchor, anchor);
			current = true;

			if (!mounted) {
				dispose = listen(window, "keydown", /*handleKeydown*/ ctx[4]);
				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			set_attributes(iframe, iframe_data = get_spread_update(iframe_levels, [
				{
					class: "purchase-confirmation-bridge__iframe"
				},
				dirty & /*attributes*/ 2 && /*attributes*/ ctx[1]
			]));

			toggle_class(iframe, "wcl-1elol4w", true);

			if (!current || dirty & /*styles*/ 4) {
				attr(div, "style", /*styles*/ ctx[2]);
			}

			if (dirty & /*$isLoading*/ 8) {
				toggle_class(div, "hidden", /*$isLoading*/ ctx[3]);
			}

			if (/*$isLoading*/ ctx[3]) {
				if (if_block) {
					if (dirty & /*$isLoading*/ 8) {
						transition_in(if_block, 1);
					}
				} else {
					if_block = create_if_block();
					if_block.c();
					transition_in(if_block, 1);
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				}
			} else if (if_block) {
				group_outros();

				transition_out(if_block, 1, 1, () => {
					if_block = null;
				});

				check_outros();
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (detaching) detach(t);
			if (if_block) if_block.d(detaching);
			if (detaching) detach(if_block_anchor);
			mounted = false;
			dispose();
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let $isLoading,
		$$unsubscribe_isLoading = noop,
		$$subscribe_isLoading = () => ($$unsubscribe_isLoading(), $$unsubscribe_isLoading = subscribe(isLoading, $$value => $$invalidate(3, $isLoading = $$value)), isLoading);

	$$self.$$.on_destroy.push(() => $$unsubscribe_isLoading());
	let { isLoading } = $$props;
	$$subscribe_isLoading();
	let { attributes } = $$props;
	let { styles } = $$props;
	let { closeApplicationAndResolve } = $$props;

	function handleKeydown(e) {
		if (e.key === 'Escape') {
			closeApplicationAndResolve(PURCHASE_STATUSES.CANCELLED);
		}
	}

	disableBodyOverflow(true);

	$$self.$$set = $$props => {
		if ('isLoading' in $$props) $$subscribe_isLoading($$invalidate(0, isLoading = $$props.isLoading));
		if ('attributes' in $$props) $$invalidate(1, attributes = $$props.attributes);
		if ('styles' in $$props) $$invalidate(2, styles = $$props.styles);
		if ('closeApplicationAndResolve' in $$props) $$invalidate(5, closeApplicationAndResolve = $$props.closeApplicationAndResolve);
	};

	return [
		isLoading,
		attributes,
		styles,
		$isLoading,
		handleKeydown,
		closeApplicationAndResolve
	];
}

class App extends SvelteComponent {
	constructor(options) {
		super();

		init(this, options, instance, create_fragment, safe_not_equal, {
			isLoading: 0,
			attributes: 1,
			styles: 2,
			closeApplicationAndResolve: 5
		});
	}
}

export { App as default };
//# sourceMappingURL=App.svelte.js.map
